import { extendTheme } from "@chakra-ui/react";

import ChakraUIInputStyling from "constants/ChakraUIComponentsStyling/ChakraUIInputStyling";

import ChakraUICardStyling from "constants/ChakraUIComponentsStyling/ChakraUICardStyling";

import ChakraUIMenuStyling from "constants/ChakraUIComponentsStyling/ChakraUIMenuStyling";
import ChakraUITabsStyling from "constants/ChakraUIComponentsStyling/ChakraUITabsStyling";

import ChakraUISelectStyling from "constants/ChakraUIComponentsStyling/ChakraUISelectStyling";

import ChakraUIModalStyling from "constants/ChakraUIComponentsStyling/ChakraUIModalStyling";
import ChakraUIButtonStyling from "constants/ChakraUIComponentsStyling/ChakraUIButtonStyling";

import ChakraUIAccordionStyling from "constants/ChakraUIComponentsStyling/ChakraUIAccordionStyling";

import ChakraUIAvatarStyling from "constants/ChakraUIComponentsStyling/ChakraUIAvatarStyling";

import ChakraUIRadioButtonStyling from "constants/ChakraUIComponentsStyling/ChakraUIRadioButton";

const CustomThemechakraUI = extendTheme({
  components: {
    Input: ChakraUIInputStyling,
    Button: ChakraUIButtonStyling,
    Card: ChakraUICardStyling,
    Menu: ChakraUIMenuStyling,
    Tabs: ChakraUITabsStyling,
    Select: ChakraUISelectStyling,
    Modal: ChakraUIModalStyling,
    Accordion: ChakraUIAccordionStyling,
    Avatar: ChakraUIAvatarStyling,
    Radio: ChakraUIRadioButtonStyling,
  },
});

export default CustomThemechakraUI;
